import React from "react";
import QuestionDetailsComponent from "./QuestionDetailsComponent";

class PhoneComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = {
      phone: '',
      pattern: `[0]{1}[0-9]{2}[-]{1}[0-9]{7}`,
      pattern2: `[0]{1}[0-9]{2}[0-9]{7}`,
      question: props.question,
    };
  }

  setPhone = (newPhone) => {
    const formattedPhone = this.sliceValue(newPhone);
    this.setState({ phone: formattedPhone });
  }

  sliceValue = (value) => {
    if (!value) return;
    const numericPhone = value.replace(/\D/g, '');
    if (numericPhone) {
      const formattedPhone = `${numericPhone.slice(0, 3)}-${numericPhone.slice(3, 10)}`;
      return formattedPhone;
    } else {
      return '';
    }
  }
  
  handleBlur(e) {
    const { pattern, pattern2, question } = this.state;
    const scope = e.closest('.question');
    const question_header = scope.querySelector('.question_header');
    const button_next = document.querySelector('.button_next');
    const error_message = scope.querySelectorAll('.error_message');
    const condPattern = '[A-Za-z]{2}[0-9]{9}[A-Za-z]{2}';

    error_message && error_message.forEach((item) => item.remove());

    const postNumber = document.getElementById('singleline31548331-612F-4676-A67D-0B9C62F428B0');
    const postNumberValue = postNumber.value;
    const scopePost = postNumber.closest('.question');
    const errorPost = scopePost.querySelectorAll('.error_message');

    if (postNumberValue) {
      if (postNumberValue.length === 13 && postNumberValue.match(condPattern)) {
        if (!e.value && !question.mandatory) {
          button_next.removeAttribute('disabled');
          this.setPhone(e.value);
          this.props.setAnswer(this.props, {target:e});
        } else {
          if (e.value.match(pattern) || e.value.match(pattern2)) {
            button_next.removeAttribute('disabled');
          } else {
            button_next.disabled = true;
            const html = `<div class="error_message">กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง ตัวอย่าง 0811234567</div>`;
            question_header.insertAdjacentHTML('afterend', html);
          }
        }
      } else {
        errorPost && errorPost.forEach((item) => item.remove());
        const html = `<div class="error_message">กรุณากรอกหมายเลขพัสดุ 13 หลัก ตัวอย่าง EF582621151TH</div>`;
        scopePost.querySelector('.question_header').insertAdjacentHTML('afterend', html);
        button_next.disabled = true;
      }
    } else {
      errorPost && errorPost.forEach((item) => item.remove());
      if (e.value.match(pattern) || e.value.match(pattern2)) {
        button_next.removeAttribute('disabled');
      } else if (!e.value) {
        button_next.removeAttribute('disabled');
      } else {
        button_next.disabled = true;
        const html = `<div class="error_message">กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง ตัวอย่าง 0811234567</div>`;
        question_header.insertAdjacentHTML('afterend', html);
      }
    }

    e.value = this.sliceValue(e.value) || '';
    this.setPhone(e.value);
    this.props.setAnswer(this.props, {target:e});
  }

  render() {
    const { question, answer } = this.props;
    const { value } = answer;
    const phone = this.state.phone ? this.state.phone : value;
    const { elementKey, questionContent } = question;
    const { helpText } = questionContent;
    return (
      <div id={`${elementKey}`} className={`question text_phone`}>
        <QuestionDetailsComponent {...this.props} />
        <div className="question_element">
          <input
            id={`phone${elementKey}`}
            type="phone"
            defaultValue={phone}
            placeholder={helpText}
            onBlur={e=>this.handleBlur(e.currentTarget)}
            pattern="[0-9]*"
          />
        </div>
      </div>
    );
  }
}

export default PhoneComponent;
